import { JSX, useState } from 'react';
import styled from 'styled-components';
import Button from '../../Button/index.tsx';
import toRem from 'utils/toRem';
import { grey70 } from 'constants/variables.js';
import { ChevronIcon } from 'assets/icons';

export interface AccordionItemProps {
  className?: string;
  id: number;
  title: string;
  activeTitle?: string;
  content: string;
  index: number;
  iconClosed?: JSX.Element;
  iconOpen?: JSX.Element;
  numbered?: boolean;
}

const StyledAccordionItem = styled.li`
  display: flex;
  width: 100%;
  flex-direction: column;
  cursor: pointer;
  min-height: ${toRem(40)};
  border: 0;
  justify-content: space-between;
  border-bottom: ${toRem(1)} solid black;
`;

const StyledButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledIconButton = styled(Button)`
  border: 0;
  background: none;
`;

const StyledQuestionButton = styled(Button)`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  margin: ${toRem(20)} 0;
  font-weight: 400;
  background: none;
  &--active {
    width: 100%;
    justify-content: flex-start;
    font-weight: bold;
    margin: ${toRem(20)} 0;
    background: none;
  }
`;

const StyledItemQuestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledItemContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 ${toRem(20)} ${toRem(16)} ${toRem(20)};
`;

const StyledAccordionIconWrapper = styled.div`
  svg {
    cursor: pointer;
  }
`;

const AccordionItem = ({
  className,
  id,
  iconClosed = (
    <ChevronIcon width={13} height={8} direction="down" fillColor={grey70} />
  ),
  iconOpen = (
    <ChevronIcon width={13} height={8} direction="up" fillColor={grey70} />
  ),
  title,
  activeTitle,
  content,
  index,
  numbered,
}: AccordionItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <StyledAccordionItem
      key={id}
      className={className}
      onClick={() => setIsOpen(!isOpen)}>
      <StyledButtonWrapper className="accordion-item__question-wrapper">
        {numbered && <span>{index + 1}.</span>}
        <StyledItemQuestion className="accordion-item__question">
          <StyledQuestionButton
            className={`accordion-item__button${isOpen ? '--active' : ''}`}
            type="button"
            handleClick={() => {
              setIsOpen(!isOpen);
            }}>
            {activeTitle && isOpen ? activeTitle : title}
          </StyledQuestionButton>
          <StyledIconButton
            className="accordion-item__icon-button"
            handleClick={() => {
              setIsOpen(!isOpen);
            }}
            handleOnKeyDown={(e: { keyCode: number }) => {
              if (e.keyCode === 13) {
                setIsOpen(!isOpen);
              }
            }}>
            <StyledAccordionIconWrapper
              className={`accordion-item__icon${isOpen ? '--active' : ''}`}>
              {isOpen ? iconOpen : iconClosed}
            </StyledAccordionIconWrapper>
          </StyledIconButton>
        </StyledItemQuestion>
      </StyledButtonWrapper>

      {isOpen && (
        <StyledItemContent className="accordion-item__content">
          {content}
        </StyledItemContent>
      )}
    </StyledAccordionItem>
  );
};

export default AccordionItem;
